import angular from "angular";

angular
    .module('app')
    .component('lessonFormFile', {
        template: require('./lesson-form-file.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', '$sce', 'Upload', '$scope', 'notify', '$uibModal', '$timeout', controller],
        bindings: {
            course: '<',
            lesson: '<',
            chapters: '<',
        }
    });

function controller($http, ErrorResponseParser, Notifier, $sce, Upload, $scope, notify, $uibModal, $timeout) {

    let $ctrl = this;

    $ctrl.currentFileIndex = null;
    $ctrl.uploadFiles = [];
    $ctrl.fileName = null;
    $ctrl.nameFromResponse = null;

    $ctrl.$onInit = function () {
        $ctrl.FileNameInputState = false;
        $ctrl.files = $ctrl.lesson.files;
        $ctrl.course_id = $ctrl.course.id;
        $ctrl.lesson_id = $ctrl.lesson.id;
    };

    // $ctrl.save = function () {
    //
    //     let data = [];
    //
    //     $ctrl.data.forEach(function (item) {
    //         if (item.type == 'text') {
    //             data.push(item);
    //         }
    //         if (item.type == 'video') {
    //             data.push({type: 'video', video_id: item.video.id});
    //         }
    //         if (item.type == 'image') {
    //             data.push(item);
    //         }
    //         if (item.type == 'vimeo') {
    //             data.push(item);
    //         }
    //     });
    //
    //     $ctrl.loading = true;
    //
    //     Upload.upload({
    //         url: `/admin/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}`,
    //         data: {
    //             _method: 'PUT',
    //             title: $ctrl.title,
    //             data: data,
    //         }
    //     }).then(
    //         function (response) {
    //             $ctrl.lesson.title = $ctrl.title;
    //             $ctrl.loading = false;
    //             Notifier.success('Данные успешно сохранены', 2);
    //         },
    //         function (error) {
    //             Notifier.error('Произошла ошибка', 2);
    //             $ctrl.loading = false;
    //         }
    //     );
    //
    // };

    // $ctrl.updateOpenForDemo = function () {
    //     $http
    //         .post(`/admin/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}/update-open-for-demo`, {
    //             open_for_demo: $ctrl.openForDemo
    //         })
    //         .then(
    //             function () {
    //                 Notifier.success('Успешно обновлен', 2);
    //             },
    //             function () {
    //                 Notifier.error('Произошла ошибка', 2);
    //                 $ctrl.openForDemo = !$ctrl.openForDemo;
    //             }
    //         )
    // };

    $ctrl.uploadFileModal = function () {
        $uibModal
            .open({
                component: 'fileUploadModal',
                size: 'md',
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    },
                    lesson: function () {
                        return $ctrl.lesson;
                    }
                }
            })
            .result
            .then(
                function (result) {
                    $ctrl.files.push(result);
                },
                function () {

                }
            )
    };

    $ctrl.submitNewFileName = function () {
        $ctrl.loading = true;
        let params = {
            newFileName: $ctrl.fileName + '.' + getFileExtension($ctrl.file.name)
        };

        $http
            .post(`/admin/courses/${$ctrl.course_id}/lessons/${$ctrl.lesson_id}/files/${$ctrl.file.id}/update-name`, params)
            .then(
                function (response) {
                    $ctrl.loading = false;
                    Notifier.success('Название файла успешно изменено', 3);
                    window.location = `/admin/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson_id}/files`;
                },
                function (error) {
                    Notifier.error(error.data.message, 3);
                    $ctrl.loading = false;
                }
            );
    };

    // $ctrl.addText = function () {
    //     $ctrl.data.push({
    //         type: 'text',
    //         content: null
    //     });
    // };

    // $ctrl.upItem = function (ind) {
    //     if (ind > 0) {
    //         let t = $ctrl.data[ind - 1];
    //         $ctrl.data[ind - 1] = $ctrl.data[ind];
    //         $ctrl.data[ind] = t;
    //     }
    // };

    // $ctrl.downItem = function (ind) {
    //     if (ind < $ctrl.data.length - 1) {
    //         let t = $ctrl.data[ind + 1];
    //         $ctrl.data[ind + 1] = $ctrl.data[ind];
    //         $ctrl.data[ind] = t;
    //     }
    // };

    // $ctrl.selectVideoModal = function () {
    //     $uibModal
    //         .open({
    //             component: 'videoSelectModal',
    //             size: 'lg'
    //         })
    //         .result
    //         .then(
    //             function (video) {
    //                 $ctrl.data.push({
    //                     type: 'video',
    //                     video: video,
    //                 });
    //             },
    //             function () {
    //
    //             }
    //         )
    // };

    // $ctrl.addVimeoVideo = function () {
    //     $uibModal
    //         .open({
    //             component: 'vimeoVideoModal',
    //             size: 'md',
    //             resolve: {
    //                 lesson: function () {
    //                     return $ctrl.lesson;
    //                 },
    //                 course: function () {
    //                     return $ctrl.course
    //                 }
    //             }
    //         })
    //         .result
    //         .then(
    //             function (video) {
    //
    //                 $ctrl.data.push({
    //                     type: 'vimeo',
    //                     html: video.html,
    //                     link: video.link
    //                 });
    //             },
    //             function () {
    //
    //             }
    //         )
    // };

    // $ctrl.uploadVideoModal = function () {
    //     $uibModal
    //         .open({
    //             component: 'videosUploadModal',
    //             size: 'lg',
    //         })
    //         .result
    //         .then(
    //             function (result) {
    //                 let video = result[0];
    //                 $ctrl.data.push({
    //                     type: 'video',
    //                     video: video,
    //                 });
    //             },
    //             function () {
    //             }
    //         )
    // };

    // $ctrl.selectImageModal = function () {
    //     $uibModal
    //         .open({
    //             component: 'uploadImage',
    //             size: 'md',
    //         })
    //         .result
    //         .then(
    //             function (result) {
    //                 $ctrl.data.push({
    //                     type: 'image',
    //                     image: result
    //                 });
    //             },
    //             function (err) {
    //
    //             }
    //         )
    // };


    // $ctrl.test = function () {
    //     Upload
    //         .upload({
    //             url: `/admin/lessons/${$ctrl.lesson.id}/upload-video`,
    //             file: $ctrl.video,
    //             resumeChunkSize: '10MB'
    //         })
    //         .then(
    //             function (resp) {
    //                 console.log(resp);
    //                 // console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
    //             },
    //             function (error) {
    //                 console.log('Error status: ' + resp.status);
    //             },
    //             function (evt) {
    //                 console.log(evt);
    //                 var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
    //                 console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
    //             }
    //         );
    // };

    // $ctrl.removeDataItem = function (key) {
    //     if (confirm("Вы уверены?")) {
    //         $ctrl.data.splice(key, 1);
    //     }
    // };

    $ctrl.removeLessonFile = function (item, key) {

        if (item.deleteLoading) {
            return;
        }

        if (!confirm('Вы уверены?')) {
            return;
        }

        item.deleteLoading = true;

        $http.delete(`/admin/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}/files/${item.id}`).then(
            function (response) {
                Notifier.success('Файл успешно удален', 2);
                $ctrl.files.splice(key, 1);
            }, function (error) {

                item.deleteLoading = false;
                Notifier.error('Произошла ошибка', 2);
            })
    };

    $ctrl.showFileNameInput = function (file, index) {
        $ctrl.FileNameInputState = true;
        $ctrl.currentFileIndex = index;
        $ctrl.file = file;
        $ctrl.fileName = file.name;
        $ctrl.fileName = $ctrl.fileName.split('.').slice(0, -1).join('.');
    };

    function getFileExtension(filename) {
        return filename
            .split('.')
            .slice(-1)[0];
    }

    // $ctrl.trustHtml = function (html) {
    //     return $sce.trustAsHtml(html);
    // };

}
